import React from 'react';
import { displayOptionTitleCase } from '../../utils/displayText';

interface MarketOptionData {
  id: string;
  label: string;
  percentage: number;
  votes: number; // Total deposits in SOL
  isLeading: boolean;
  isWinner?: boolean;
}

interface MarketOptionProps {
  option: MarketOptionData;
  isSelected: boolean;
  hasSelection: boolean;
  onSelect: (optionId: string) => void;
  disabled?: boolean;
}

export const MarketOption: React.FC<MarketOptionProps> = ({
  option,
  isSelected,
  hasSelection,
  onSelect,
  disabled = false
}) => {
  // Add 'not-selected' class when there's a selection but this isn't the selected option
  const notSelectedClass = hasSelection && !isSelected ? 'not-selected' : '';
  // Winner/loser classes: isWinner is undefined for active markets, true/false for ended markets
  const outcomeClass = option.isWinner === true ? 'winner' : option.isWinner === false ? 'loser' : '';
  
  return (
    <button 
      className={`consensus-option-button ${isSelected ? 'selected' : ''} ${notSelectedClass} ${option.isLeading ? 'leading' : ''} ${outcomeClass}`}
      onClick={() => onSelect(option.id)}
      disabled={disabled}
    >
      <div className="option-content">
        <span className="option-label" title={option.label}>{displayOptionTitleCase(option.label)}</span>
        <span className="option-stats">
          {option.percentage.toFixed(0)}% | <img src="/assets/icons/solanaLogoMark.svg" alt="SOL" className="sol-icon" />{option.votes.toFixed(2)}
        </span>
      </div>
    </button>
  );
};
